import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AbstractControl, FormGroup, ValidatorFn} from '@angular/forms';
import {Observable} from 'rxjs';
import {IWorkingPeriodDropdowns} from 'src/app/interfaces/employee-edit-mode.interface';
import {
  INewWorkingPeriod,
  workingPeriodStatus,
} from 'src/app/interfaces/termination.interface';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkingPeriodService {
  private _workingPeriodForm!: FormGroup;
  private _currentStatus!: string;
  private urlEmployee = environment.API + 'api/v1/Employee/';

  constructor(private http: HttpClient) {}

  get getWorkingPeriod(): FormGroup {
    return this._workingPeriodForm;
  }

  set setWorkingPeriod(form: FormGroup) {
    this._workingPeriodForm = form;
  }

  get getCurrentStatus(): string {
    return this._currentStatus;
  }

  set setCurrentStatus(status: string) {
    this._currentStatus = status;
  }

  get isNewStatusContractor(): boolean {
    return this.newStatus! === workingPeriodStatus.ContractorPT;
  }

  get isNewStatusEmployee(): boolean {
    return this.newStatus! === workingPeriodStatus.Employee;
  }

  get newStatus(): string {
    return this.formControl('newStatus')?.getRawValue()?.name;
  }

  get rate(): AbstractControl {
    return this._workingPeriodForm.get('rate')!;
  }

  get stavka(): AbstractControl {
    return this._workingPeriodForm.get('stavka')!;
  }

  setValidators(
    controlName: string,
    validators: ValidatorFn | ValidatorFn[] | null
  ) {
    this._workingPeriodForm.get(controlName)?.setValidators(validators);
  }

  formControl(controlName: string): AbstractControl {
    return this._workingPeriodForm.get(controlName)!;
  }

  getDropdowns(): Observable<IWorkingPeriodDropdowns> {
    return this.http.get<IWorkingPeriodDropdowns>(
      `${this.urlEmployee}general/terminations/editMode`
    );
  }

  public addNewTermination(
    termination: INewWorkingPeriod,
    employeeId: number
  ): Observable<void> {
    termination.employeeId = employeeId;
    return this.http.post<void>(
      `${this.urlEmployee}general/terminations`,
      termination
    );
  }

  public deleteTermination(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.urlEmployee}general/termination/delete/${id}`
    );
  }
}
